// extracted by mini-css-extract-plugin
module.exports = {"pt-old-to-new-table":"pt-old-to-new-table-43785d146ca7b268cbd07702e904eb1a"};